/** USPS accepts up to 35 tracking numbers, comma-separated, in one lookup. */
const MAX_NUMBERS = 35

/** Splits what the customer typed into clean tracking numbers (spaces and dashes removed). */
export function parseTrackingNumbers(input: string): string[] {
  return input
    .split(/[,;\n]+/)
    .map((part) => part.replace(/[\s-]/g, '').toUpperCase())
    .filter(Boolean)
    .slice(0, MAX_NUMBERS)
}

/** USPS tracking numbers are letters and digits, roughly 10 to 34 characters. */
export function isLikelyTrackingNumber(value: string): boolean {
  return /^[A-Z0-9]{10,34}$/.test(value)
}

/** Opens USPS's own tracking page with the numbers already filled in. */
export function uspsTrackingUrl(numbers: string[]): string {
  return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encodeURIComponent(numbers.join(','))}`
}
